export { default } from 'shared/components/loader'
